import { render, staticRenderFns } from "./AppLabel.vue?vue&type=template&id=941205a2"
import script from "./AppLabel.vue?vue&type=script&lang=js"
export * from "./AppLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports